import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import { InstitutionFieldDocument } from '@/features/institution/components/fields/document';
import type { InstitutionKycCddOrDefaults } from '@/features/institution/kyc-cdd/schema';
import { DocumentSource } from '@/services/api/documents';

const InstitutionKycCddFieldsetPolicy = () => {
  const form = useFormContext<InstitutionKycCddOrDefaults>();
  const { t } = useTranslation();
  const cddPolicy = form.watch('cddPolicy');

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="cddPolicy"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.policy.cddPolicy')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.kycCdd.policy.cddPolicy')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {cddPolicy === 'YES' ? (
        <InstitutionFieldDocument<InstitutionKycCddOrDefaults>
          label={t('institutionDetails.kycCdd.policy.cddPolicyDocument')}
          name="cddPolicyDocument"
          source={DocumentSource.LICENCES_AND_POLICIES}
        />
      ) : null}
    </div>
  );
};
InstitutionKycCddFieldsetPolicy.displayName = 'InstitutionKycCddFieldsetPolicy';

export { InstitutionKycCddFieldsetPolicy };
